import { settings } from "./default";
import config from "@/config/config";
import deepMerge from "deepmerge";

export default deepMerge(settings, config);
